import { render, staticRenderFns } from "./OrganismConfirmForgotPassword.vue?vue&type=template&id=4e12bed6&"
import script from "./OrganismConfirmForgotPassword.vue?vue&type=script&lang=js&"
export * from "./OrganismConfirmForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports